<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M3.29175 10H4.79175M8.16675 10H9.66675M8.16675 7H11.1667M3.29175 7H4.79175M3.29175 13H4.79175M5.54175 16.375H13.7917C14.6202 16.375 15.2917 15.7034 15.2917 14.875V5.125C15.2917 4.29657 14.6202 3.625 13.7917 3.625H5.54175C4.71332 3.625 4.04175 4.29657 4.04175 5.125V14.875C4.04175 15.7034 4.71332 16.375 5.54175 16.375Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'TechnicalDocsIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>